import { RadioGroup } from '@heroui/react'
import type { ReturnsProductDetailsResponseVariantInfo } from '@itsrever/rever-api'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { ProductVariantButton } from './product-variant-button'

interface ProductVariantSelectorProps {
    variants: ReturnsProductDetailsResponseVariantInfo[]
    onVariantSelect: (variantId: string) => void
    selectedVariantId?: string
}

export const ProductVariantSelector = ({
    variants,
    onVariantSelect,
    selectedVariantId
}: ProductVariantSelectorProps) => {
    const { t } = useTranslation()

    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )

    const isHoff = settings.ecommerce_group === 'hoff'

    if (isHoff) {
        return (
            <RadioGroup
                aria-label={t('full_catalog.select_option')}
                onValueChange={onVariantSelect}
                value={selectedVariantId}
                orientation="vertical"
                classNames={{ wrapper: 'gap-0 divide-y-1 divide-black' }}
            >
                {variants.map((variant) => (
                    <ProductVariantButton
                        value={variant.platform_id ?? ''}
                        key={variant.platform_id}
                        variant={variant}
                    />
                ))}
            </RadioGroup>
        )
    }

    return (
        <RadioGroup
            aria-labelledby="variant-options"
            onValueChange={onVariantSelect}
            value={selectedVariantId}
            orientation="vertical"
        >
            {variants.map((variant) => (
                <ProductVariantButton
                    value={variant.platform_id ?? ''}
                    key={variant.platform_id}
                    variant={variant}
                />
            ))}
        </RadioGroup>
    )
}
